import { groupMessagesByDate } from "../format-date/format-date";

export const createChatHandlers = ({
  setChatHistory,
  setMessages,
  setPage,
  setRemainingMessages,
  setHasMore,
  setSelectedChat,
  selectedRoleRef,
  receiverIdRef,
  isSupportPathRef,
  isSuperAdminRef,
}) => {
  const handleChatOverview = (res) => {
    if (res?.role !== selectedRoleRef.current || isSupportPathRef.current) return;
    setChatHistory(res?.data || []);
  };

  const handleMessages = (msg) => {
    if (msg?.receiverId !== receiverIdRef.current || isSupportPathRef.current) return;
    setMessages((prev) => {
      const newMessages = msg?.data || [];
      const existingMessages = msg?.page === 1 ? [] : prev;
      return groupMessagesByDate(newMessages, existingMessages);
    });
    setPage(msg?.page);
    setRemainingMessages(msg?.remainingMessages);
    setHasMore(!!msg?.data?.length && msg?.page !== msg?.totalPages);
  };

  const handleSupportOverview = (res) => {
    if (res?.role !== selectedRoleRef.current || !isSupportPathRef.current) return;
    setChatHistory(res?.data || []);
    if (isSuperAdminRef.current) return;
    setSelectedChat(res?.data?.[0] || null);
  };

  const handleSupportMessages = (msg) => {
    if (msg?.receiverId !== receiverIdRef.current || !isSupportPathRef.current) return;
    setMessages((prev) => {
      const newMessages = msg?.data || [];
      const existingMessages = msg?.page === 1 ? [] : prev;
      return groupMessagesByDate(newMessages, existingMessages);
    });
    setPage(msg?.page);
    setRemainingMessages(true);
    setHasMore(!!msg?.data?.length && msg?.page !== msg?.totalPages);
  };

  return {
    handleChatOverview,
    handleMessages,
    handleSupportOverview,
    handleSupportMessages,
  };
};
